export const styles = {
  filterTagsBox: {
    paddingBottom: "20px",
    maxWidth: "300px",
  },

  textSize: {
    "& .MuiTypography-root": {
      fontSize: "14px",
      color: "events.blueSecondary",
    },
  },
  buttonText: {
    width: "250px",
    "& .MuiTypography-root": {
      fontSize: "14px",
    },
  },
};
